module.exports = __webpack_public_path__ + "img/rotate1.bd08a2c5.png";